/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.rest.client.internal

import io.ktor.http.Headers
import systems.frictionless.impulse.rest.client.model.RestResponse

internal data class ResponseWithHeaders<T>(val response: RestResponse<T>, val headers: Headers) {
    /**
     * @param remapper Maps a successful response to a different representation.
     */
    fun <U> remap(remapper: (success: RestResponse.Success<T>, headers: Headers) -> RestResponse<U>): RestResponse<U> {
        return when (response) {
            is RestResponse.Success -> {
                remapper(response, headers)
            }
            is RestResponse.Failure.Connection -> {
                RestResponse.Failure.Connection(response.throwable)
            }
            is RestResponse.Failure.Client -> {
                RestResponse.Failure.Client(response.throwable)
            }
            is RestResponse.Failure.Server -> {
                RestResponse.Failure.Server(response.httpStatusCode, response.serverError)
            }
        }
    }
}
